(function (app) {

    let absencesTypesFactory;

    var ApprovedRequestsDataService = function () {
        var self = this;

        var DATE_FORMAT = 'MMM DD, YYYY';
        var MINUTE = 60 * 1000;
        var HOUR = 60 * MINUTE;

        var startDate;
        var endDate;

        var data = {
            approved_requests: {},
            periods_by_date: {},
            users_approved_requests: {},
            periods_by_ids: {},
            excluded_periods_by_date: {}
        };

        var viewSlotsData = {};

        var brand;
        var users = {};

        var slots;
        var hasAnyRequestPermission;

        // public attributes

        self.getShiftDay = function (shiftStartTime) {
            var shiftStartDate = new Date(shiftStartTime);
            var shiftStartHour = shiftStartDate.getHours() * HOUR + shiftStartDate.getMinutes() * MINUTE;

            if (shiftStartHour < self.dayOpenHour) {
                shiftStartDate = shiftStartDate.getTime() - (24 * HOUR);
            }

            return moment(shiftStartDate).format("MMM DD, YYYY HH:mm:ss");
        };

        self.setBusinessDay = function (selectedDay, businessDays) {
            var selectedDayTime = new Date(selectedDay).getTime();
            self.businessDays = businessDays || self.businessDays;

            for (var i in self.businessDays) {
                var businessDayTime = moment(self.businessDays[i].start_date, "YYYY-MM-DD").valueOf();

                if (selectedDayTime >= businessDayTime) {
                    self.businessDay = self.businessDays[i];
                    break;
                }
            }

            self.dayOpenHour = self.businessDay? self.businessDay.open_time * 1000: 0; // From seconds to millis
            self.dayCloseHour = self.businessDay? self.businessDay.close_time * 1000: 0; // From seconds to millis

            if (self.dayCloseHour <= self.dayOpenHour) {
                self.dayCloseHour += 24 * 60 * 60 * 1000; // One day shift
            }
        };

        self.reset = function () {
            data = {
                approved_requests: {},
                periods_by_date: {},
                users_approved_requests: {},
                periods_by_ids: {},
                excluded_periods_by_date: {}
            };

            viewSlotsData = {};
        };

        self.parseData = function (requestsData, brand) {
            const absencesTypesList = absencesTypesFactory.getBrandAbsenceTypes(brand?.brand_absences);

            for (var i in requestsData) {
                var approvedRequest = requestsData[i];
                var calculatedSlotsFromPeriods = [];

                approvedRequest.periods = approvedRequest.periods || [];

                for (var j in approvedRequest.periods) {
                    var period = approvedRequest.periods[j];
                    var startAt = moment(period.start_time);
                    var endAt = moment(period.end_time);

                    if (absencesTypesList.includes(period.type)) {
                        period.type = "CUSTOM";
                    }

                    while (startAt.valueOf() < endAt.valueOf()) {
                        var newPeriod = {};
                        newPeriod.id = period.id;
                        newPeriod.is_all_day = period.is_all_day;
                        newPeriod.type = period.type;
                        newPeriod.start_time = startAt.format(DATE_FORMAT + ' HH:mm:ss');

                        var endDateCopy = startAt.clone();

                        if (startAt.hours() >= endAt.hours()) {
                            endDateCopy.add(1, 'day');
                        }

                        newPeriod.end_time = endDateCopy.format(DATE_FORMAT + ' ' + endAt.format('HH:mm:ss'));

                        calculatedSlotsFromPeriods.push(newPeriod);
                        startAt.add(1, 'day');
                    }
                }

                approvedRequest.periods = calculatedSlotsFromPeriods;

                for (var j in approvedRequest.periods) {
                    var period = approvedRequest.periods[j];
                    var startAt = moment(self.getShiftDay(period.start_time));

                    period.user_id = approvedRequest.user_id;
                    period.accual_status = approvedRequest.status;
                    period.status = ['PENDING_APPROVAL', 'RETURNED_TO_WORK', 'OPEN'].indexOf(approvedRequest.status) > -1 ? 'PENDING_APPROVAL' : 'APPROVED';
                    data.periods_by_date[startAt.format(DATE_FORMAT)] = data.periods_by_date[startAt.format(DATE_FORMAT)] || [];
                    data.periods_by_date[startAt.format(DATE_FORMAT)].push(period);
                    data.periods_by_ids[period.id] = period;
                }

                data.approved_requests[approvedRequest.id] = approvedRequest;
                data.users_approved_requests[approvedRequest.user_id] = data.users_approved_requests[approvedRequest.user_id] || [];
                data.users_approved_requests[approvedRequest.user_id].push(approvedRequest);
            }
        };

        self.getViewSlotsByDate = function (date) {
            return viewSlotsData[date];
        };

        self.updateViewSlots = function (date, slot) {
            viewSlotsData[date] = viewSlotsData[date] || [];
            viewSlotsData[date].push(slot);
        };

        self.setEndDate = function (endDateMoment) {
            endDate = endDateMoment;
        };

        self.getTeamRequestsData = function () {
            return data;
        };

        self.updateExcludedRequests = function (filters) {
            data.excluded_periods_by_date = {};
            var filteredPeriods = {};

            for (var date in data.periods_by_date) {
                var datePeriods = data.periods_by_date[date];

                for (var i = 0; i < datePeriods.length ; i++) {
                    var periodDetails = datePeriods[i];
                    var user = self.getUser(periodDetails.user_id);
                    var positions = user && user.positions;

                    if (
                        filters['user'] &&
                        datePeriods.user_id != filters['user'].id
                    ) {
                        continue;
                    }

                    if (filters['type']) {
                        var types = filters['type'].split(',');

                        if (types.indexOf('CUSTOM') > -1 || types.indexOf('HOLIDAY') > -1) {
                            if (['CUSTOM', 'HOLIDAY'].indexOf(periodDetails.type) === -1) {
                                continue;
                            }
                        } else if (types.indexOf(periodDetails.type) === -1) {
                            continue;
                        }
                    }

                    var notAddToView = false;

                    if (filters['categories'] && filters['categories'].length) {
                        notAddToView = true;

                        for (var k in positions) {
                            var position = positions[k];

                            if (position.category && filters['categories'].indexOf(position.category.code) > -1) {
                                notAddToView = false;
                                break;
                            }
                        }
                    }

                    if (filters['positions'] && filters['positions'].length) {
                        notAddToView = true;

                        for (var k in positions) {
                            var position = positions[k];

                            if (position.category && filters['positions'].indexOf(position.code) > -1) {
                                notAddToView = false;
                                break;
                            }
                        }
                    }

                    if (notAddToView) {
                        continue;
                    }

                    filteredPeriods[date] = filteredPeriods[date] || [];
                    filteredPeriods[date].push(periodDetails);
                }
            }

            for (var date in filteredPeriods) {
                var periods = filteredPeriods[date];

                if (periods.length > 4) {
                    for (var i = (periods.length - 1); i > 3; i--) {
                        var period = periods[i];

                        data.excluded_periods_by_date[date] = data.excluded_periods_by_date[date] || [];
                        data.excluded_periods_by_date[date].push(period.id);
                    }
                }
            }
        };

        self.getExcludedRequests = function (date) {
            return data.excluded_periods_by_date[date];
        };

        self.getRequestById = function (slotId) {
            return data.periods_by_ids[slotId];
        };

        self.getPeriodsByDate = function (date) {
            return data.periods_by_date[date];
        };

        self.getUsersRequests = function () {
            return data.users_approved_requests;
        };

        self.getTeamRequestsDataByUserId = function (userId) {
            return data.users_approved_requests[userId];
        };

        self.setStartDate = function (startDateMoment) {
            startDate = startDateMoment;
        };

        self.getStartDate = function () {
            return startDate;
        };

        self.getEndDate = function () {
            return endDate;
        };

        self.setBrand = function (newBrand) {
            brand = newBrand;
        };

        self.getBrand = function () {
            return brand;
        };

        self.setHasAnyRequestPermission = function (hasAnyPermission) {
            hasAnyRequestPermission = hasAnyPermission;
        };

        self.getHasAnyRequestPermission = function () {
            return hasAnyRequestPermission;
        };

        self.setSlots = function (allSlots) {
            slots = allSlots;
        };

        self.getSlots = function () {
            return slots;
        };

        self.setUsers = function (usersData) {
            for (var i in usersData) {
                var user = usersData[i];
                users[user.id] = user;
            }
        };

        self.getUsers = function () {
            return users;
        };

        self.getUser = function (userId) {
            return users[userId];
        };

        self.calculatePermissionsPerRequest = function (policyParser, userPermissions, slotData, users) {
            var defer = $q.defer();
            var absenceTypePermission;
            switch (slotData && slotData.type) {
                case 'AVAILABILITY':
                case 'WORKABLE':
                case 'PREFERRED_TIME':
                    absenceTypePermission = 'MANAGE_AVAILABILITY_REQUESTS';
                    break;

                case 'TIME_OFF':
                    absenceTypePermission = 'MANAGE_TIMEOFF_REQUESTS';
                    break;

                case 'SICKNESS':
                    absenceTypePermission = 'MANAGE_SICKNESS_REQUESTS';
                    break;

                case 'LOA':
                    absenceTypePermission = 'CREATE_UPDATE_LEAVE_OF_ABSENCE';
                    break;

                default:
                    absenceTypePermission = 'MANAGE_ABSENCE_REQUESTS';
                    break;
            }

            if (slotData) {
                var manageEmployeesRequestsPermissions = true;
                var user = users.filter(function (user) {
                    return user.id === (slotData.user_id);
                })[0];
                var userPositions = user['positions'] || [];
                var hasEmployeeRequestPermission = true;

                for (let i in userPositions) {
                    let position = userPositions[i];
                    hasEmployeeRequestPermission = policyParser.positions(position.category.code, position.code)
                        .has(userPermissions.PERMISSIONS[absenceTypePermission]);

                    manageEmployeesRequestsPermissions = manageEmployeesRequestsPermissions && hasEmployeeRequestPermission;
                }
                slotData.hasTheRightPermission = manageEmployeesRequestsPermissions;
            }
            defer.resolve(slotData);

            return defer.promise;
        };
    };

    app.service('ApprovedRequestsDataService', [
        'useAbsencesTypesFactory',
        function (useAbsencesTypesFactory) {
            absencesTypesFactory = useAbsencesTypesFactory();
            return new ApprovedRequestsDataService();
        }
    ]);

})(angular.module('harriApp'));